/** Znormalizowany postęp grupy merge; -1 oznacza wariant niepodlegający merge. */
export function normalizedMergeProgress(count: number, required: number | null): number {
  if (required === null || required <= 0) return -1;
  return Math.min(1, Math.max(0, count) / required);
}

/** Comparator malejący: grupa bliższa ukończenia trafia wcześniej. */
export function compareMergeProgress(
  countA: number,
  requiredA: number | null,
  countB: number,
  requiredB: number | null,
): number {
  return normalizedMergeProgress(countB, requiredB) - normalizedMergeProgress(countA, requiredA);
}
